<template>
  <!-- 提现打款管理 -->
  <section class="draw">
    <!--工具条-->
    <el-col :span="24" class="draw_toolbar toolbar pad_left">
    <div class="main_container">
      <div class="fuji" @click="show3 = !show3">
        <p style="margin: 0;margin-left: -22px;" class="goodslist1">
          <span style="margin-left:31px;margin-top:5px">搜索/查询</span>
          <span class="goods_red"/>
        </p>
        <div style="position: absolute;right:-19px;top:-10px" class="sanjiao"></div>
      </div>
      <el-collapse-transition>
      <div style="padding-left: 20px" v-show="show3">
        <el-form class="findform" style="margin-top:10px;display:flex;">
          <!-- 顶部搜索框 -->
          <el-form-item style="display:flex;width:30%" label="提现编号：">
            <el-input style="width:100%" v-model="filters.transferNum" placeholder="提现编号"/>
          </el-form-item>
          <el-form-item style="display:flex;width:30%;margin-left:20px" label="用户名：">
            <el-input style="width:100%" v-model="filters.userTel" placeholder="用户名"/>
          </el-form-item>
          <el-form-item style="display:flex;width:30%;margin-left:20px" label="收款方名称：">
            <el-input style="width:100%" v-model="filters.payeeName" placeholder="收款方名称"/>
          </el-form-item>
          <el-form-item style="display:flex;width:10%;margin-left:10px"/>
        </el-form>
        <el-form class="findform" style="display:flex;position: relative;">
          <el-form-item style="display:flex;width:30%" label="申请时间：">
            <el-date-picker type="daterange" :title="value6" v-model="value6" style="width:100%;cursor:pointer" value-format="yyyy-MM-dd"
              range-separator="至" start-placeholder="开始日期" @change="changetime" end-placeholder="结束日期"/>
          </el-form-item>
          <el-form-item style="display:flex;width:30%;margin-left:20px" label="打款状态：">
            <el-select v-model="filters.dataStatusCode" placeholder="请选择" style="background:#fff;width:100%" ref="mySelect">
              <el-option :label="item.Name" :value="item.Id" v-for="(item,index) in paymentStatusCodeArr" :key="index"/>
            </el-select>
          </el-form-item>
          <el-form-item style="display:flex;width:30%;margin-left:20px" label="收款方卡号：">
            <el-input style="width:100%" v-model="filters.payeeAccount" placeholder="收款方卡号"/>
          </el-form-item>
          <el-form-item style="display:flex;width:10%;margin-left:10px">
            <el-button style="height:36px;line-height:1px" @click="onSubmit" class="toolbar_search">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      </el-collapse-transition>
    </div>
    </el-col>

    <!--列表-->
    <template>
      <el-col :span="24" class="draw_table pad_left">
        <section class="model_section">
          <p class="model_top_title">提现打款管理</p>
          <div class="operationList">
            <span>重要提示：待打款条目中如果同一收款方有多条待打款记录，默认导出只导出一条。</span>
            <div class="daoruClass"> 导入打款结果
              <input type="file" id="file" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" @change="importEnter" ref="pathClear"/>
            </div>
            <el-button type="danger" @click="exportOut">导出待打款</el-button>
          </div>
        </section>
        <div class="table_container" style="margin-top:10px">
          <div class="table_inner_container">
            <el-table :data="withdrawalList" class="draw_tab" stripe border style="height:auto;max-height:500px" >
              <el-table-column prop="num" label="序号"  align="center" width="68px">
                <template scope="scope">{{scope.$index + 1}}</template>
              </el-table-column>
              <el-table-column label="提现编号" align="center" width="150px">
                <template scope="scope">{{scope.row.transferNum}}</template>
              </el-table-column>
              <el-table-column label="用户名" align="center" width="110px">
                <template scope="scope">{{scope.row.userTel}}</template>
              </el-table-column>
              <el-table-column label="申请时间" align="center" width="150px">
                <template scope="scope">{{scope.row.createTime}}</template>
              </el-table-column>
              <el-table-column label="提现金额(元)" align="center" width="120px">
                <template scope="scope">{{scope.row.thisTransferAmount}}</template>
              </el-table-column>
              <el-table-column label="手续费(元)" align="center">
                <template scope="scope">{{scope.row.charges}}</template>
              </el-table-column>
              <el-table-column label="收款类型" align="center">
                <template scope="scope">{{scope.row.accountTypeName}}</template>
              </el-table-column>
              <el-table-column label="收款名称" align="center">
                <template scope="scope">{{scope.row.payeeName}}</template>
              </el-table-column>
              <el-table-column label="开户银行" align="center" width="110px">
                <template scope="scope">
                  <span class="spanList" :title="scope.row.bankBranch">{{scope.row.bankBranch}}</span>
                </template>
              </el-table-column>
              <el-table-column label="开户支行所在地" align="center" width="150px">
                <template scope="scope">{{scope.row.province}}-{{scope.row.city}}-{{scope.row.county}}</template>
              </el-table-column>
              <el-table-column label="收款卡号/账户" align="center" width="150px">
                <template scope="scope">{{scope.row.payeeAccount}}</template>
              </el-table-column>
              <el-table-column label="打款状态" align="center">
                <template scope="scope">{{scope.row.dataStatusDesc.replace('审核通过/','')}}</template>
              </el-table-column>
              <el-table-column label="打款流水编号" align="center" width="120px">
                <template scope="scope">
                  <span class="spanList" :title="scope.row.serialNumber">
                    {{scope.row.dataStatusCode==4?scope.row.examineDesc:scope.row.serialNumber}}
                  </span>
                </template>
              </el-table-column>
            </el-table>
            <el-col :span="24" style="padding-top:10px;" class="toolbar_footer">
              <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
                :page-size="10" :total="total" :current-page="pageInfo.pageNum" style="float:right;"/>
            </el-col>
          </div>
        </div>
      </el-col>
    </template>
  </section>
</template>

<script>
import { postTransferAccountsPaymentList, getExcelTransferAccountsPaymentList,
  getTransferAccountsPaymentListInfo, postUpload } from "../../api/comment";
export default {
  data() {
    return {
      show3: false,
      filters: {
        transferNum: '', // 提现编码
        userTel: "", // 手机号码
        payeeName: "", // 收款方姓名
        createDateB: "", // 日期开始日期
        createDateE: "", // 日期结束日期
        dataStatusCode: '', // 打款状态
        payeeAccount: '', // 收款方卡号
      },
      value6: '', // 申请时间
      paymentStatusCodeArr: [
        {
          Id: '',
          Name: "全部"
        },
        {
          Id: '3',
          Name: "待打款"
        },
        {
          Id: '5',
          Name: "已打款"
        },
        {
          Id: '4',
          Name: "打款失败"
        }
      ],
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
      },
      withdrawalList: [], // 提现列表
      total: 1,
      tixianshenid: "",
    };
  },
  methods: {
    // 提现打款管理
    init() {
      var addParams = {
        pageInfo: this.pageInfo, // 页码 条数
        param: this.filters
      };
      postTransferAccountsPaymentList(addParams).then(data => {
        this.withdrawalList = data.resultObj.records;
        this.total = data.resultObj.total;
      })
      .catch(err => {
        this.withdrawalList = [];
      });
    },
    // 申请时间
    changetime() {
      if( this.value6 + "" == "null" ){
        this.value6 = ["",""]
      }
      this.filters.createDateB = this.value6[0];
      this.filters.createDateE = this.value6[1];
    },
    // 导入打款结果
    importEnter(event){
      console.log(event, '导入打款结果', 'AAA');
      // 调用接口
      let obj2 = new FormData();
      obj2.append('file',event.target.files[0]);
      //上传视频获取路径
      postUpload(obj2).then(data=>{
        if (data.resultCode == 1) {
          this.$swal({
            type: "success",
            text: data.resultObj,
          });
          this.init();
        } else {
          this.$swal({
            type: "warning",
            text: data.resultMsg,
          });
          return false;
        }
      })
    },
    // 导出待打款
    exportOut() {
      var addParams = "";
      // this.downLoad();
      this.daochuTs();
      getExcelTransferAccountsPaymentList(addParams)
    },
    // 导出提示
    daochuTs() {
      var abc = {};
      getTransferAccountsPaymentListInfo(abc).then(data => {
        if (data.resultCode == 1) {
          this.$swal({
            type: "success",
            text: data.resultObj,
          });
        }
      })
    },
    // 分页
    handleCurrentChange(val) {
      this.pageInfo.pageNum = val;
      this.init();
    },
    //查询
    onSubmit() {
      this.pageInfo.pageNum = 1;
      this.init();
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped>
.el-input__inner {
  background-color: #fff;
  border: 1px solid #f2f2f2;
  cursor: pointer;
}
.draw .draw_toolbar {
  height: auto;
  color: #404040;
}
/* 时间  */
/* .draw_toolbar .line {
  margin-left: 10px;
  line-height: 36px;
} */
/* 时间图标 */
/* .draw_toolbar .line img{
  margin-top:8px
} */
/* 查询按钮 */
.draw_toolbar .el-button {
  background-color: #F56C6C;
  margin-left: 0;
  color: #fff;
  width: 78px;
  border-color: #ff4949;
}
/* 内容表格 */
.draw_table {
  min-height: 500px;
  background-color: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(14, 5, 10, 0.1);
  position: relative;
  margin-top: 10px;
}
/* 标题 */
.draw_table section {
  height: 55px;
  line-height: 55px;
  border-bottom: 1px solid #eee;
}
/* 提现审核 */
.draw_table .el-col-22 p {
  width: 60px;
  height: 55px;
 
  font-size: 14px;
  font-weight: bold;
  color: #2a2a2a;
  margin-left: 22px;
  line-height: 55px;
  border-bottom: 1px solid #F56C6C;
  margin-top: 0;
}
/* 新增按钮 */
.draw_table .el-col-2 p {
  width: 104px;
  height: 36px;
  background-color: #F56C6C;
  line-height: 36px;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  cursor: pointer;
}
/* 表格 */
.draw_tab {
  box-shadow: 0 0 0 0;
  width: 100%;
  margin: 0 auto;
  font-size: 12px;
}

/* 表格操作 */
.draw_tab .draw_operation p {
  float: left;
  color: #677c9d;
  width: 68px;
  cursor: pointer;
}
.draw_tab .draw_operation p:first-child {
  margin-left: 20%;
}

/* 分页 */
.draw_toolbar_footer {
  position: absolute;
  bottom: 10px;
}
.operationList {
  width: 52rem;
  float: right;
}
.operationList span {
  color: #F56C6C;
  margin-right: 10px;
}
.daoruClass {
  position: relative;
  display: inline-table;
  background: #F56C6C;
  color: #fff;
  border-radius: 4px;
  padding: 4px 12px;
  overflow: hidden;
  text-decoration: none;
  text-indent: 0;
  line-height: 30px;
  margin: 0 10px;
  cursor: pointer;
}
.daoruClass input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// withdrawalAndPaymentManagement.vue?401323eb